export default __webpack_public_path__ + "static/media/nurseModalPicture.8777dbe3.png";